<template>
  <div class="doorpostdescribe">
    <div class="header">
      <div class="title">完善的智慧防疫设备</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <div class="title">远程视频监控</div>
        <div class="text">
          主要用于社区、学校等远程监管人员的防疫以及密接、次密接、确诊等重点人员的监管防疫。具有精准测量体温、地理位置追踪、隔离区域越界等功能的智慧防疫设备
        </div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>

      <div class="right">
        <img :src="EBEquipmentLogo" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import EBEquipment2 from "../../../../assets/programme/EBEquipment2.png";
import EBEquipment3 from "../../../../assets/programme/EBEquipment3.png";

import EBEquipmentLogo from "../../../../assets/programme/EBEquipmentLogo.png";

export default {
  setup() {
    return reactive({
      EBEquipmentLogo: EBEquipmentLogo,
      list: [
        {
          id: 1,
          title: "远程无接触测温",
          logo: EBEquipment2,
        },
        {
          id: 2,
          title: "密接人员定位追踪",
          logo: EBEquipment2,
        },
        {
          id: 3,
          title: "居家隔离异常警报",
          logo: EBEquipment3,
        },
      ],
    });
  },
};
</script>

<style scoped>
.doorpostdescribe {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.body .right img {
  width: 600px;
}
.body .left {
  width: 534px;
}
.body .left .title {
  font-size: 16px;
}
.body .left .text {
  font-size: 14px;
  color: #495a6c;
  margin-top: 20px;
}
.body .left .list {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.body .left .list .item {
  text-align: center;
}
.body .left .list .item img {
  width: 36px;
}
.body .left .list .item div {
  font-size: 14px;
  margin-top: 20px;
  color: #495a6c;
}
</style>
